import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { IonicModule } from "@ionic/angular";

@Component({
    selector: "app-in-progress-animation",
    templateUrl: "./in-progress-animation.component.html",
    styleUrls: ["./in-progress-animation.component.scss"],
    standalone: true,
    imports: [IonicModule],
})
export class InProgressAnimationComponent implements OnInit {
  @Input() type: string;
  constructor() { }

  ngOnInit() { }
}
